





























































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        ElSelect: () => import("../../components/forms/select.vue")
    }
})
export default class EstatesSearchBar extends Vue {
    loading = false;

    cityOptions: SelectOption[] = [];

    typeOptions: SelectOption[] = [
        { id: 1, value: "house", label: "Woning" },
        { id: 2, value: "apartment", label: "Appartement" },
        { id: 3, value: "parking", label: "Parking" },
        { id: 4, value: "land", label: "Grond" },
        { id: 5, value: "office", label: "Kantoor" }
    ];

    params = {
        sale_or_let: "sale",
        type: "",
        cities: ""
    };

    private get theme(): "light" | "dark" {
        return "light";
    }

    private mounted() {
        this.getCities();
    }

    private goToEstates() {
        let params = `?sale_or_let=${this.params.sale_or_let}`;
        if (this.params.type) {
            params += `&type=${this.params.type}`;
        }
        if (this.params.cities) {
            params += `&zips=${this.params.cities}`;
        }
        window.location.href = `/aanbod${params}`;
    }

    private getCities() {
        // @ts-ignore
        axios.get("/api/zips").then((response: any) => {
            const ziplist = response.data;

            // @ts-ignore
            this.cityOptions = [];

            Object.keys(ziplist).forEach((index: string) => {
                let match: any = ziplist[index];
                let option: any = {
                    id: match.filter,
                    label: `${match.city} (${match.zip})`,
                    tagLabel: `${match.city}`,
                    selectedLabel: `<span class='flex flex-row items-center gap-[4px]'><span>${match.city}</span><small class='text-red'>${match.zip}</small></span>`,
                    value: match.filter
                };

                if (match.children) {
                    option.children = [];
                    match.children.forEach((childList: any) => {
                        option.children.push({
                            id: childList.zip,
                            parent_id: match.zip,
                            label: `${childList.city} ${childList.zip}`,
                            tagLabel: `${childList.city}`,
                            indent: true,
                            selectedLabel: `<span class='flex flex-row items-center gap-[4px] ml-16'><span>${childList.city}</span><small class='text-red'>${childList.zip}</small></span>`,
                            value: childList.filter
                        });
                    });

                    option.children.sort((a: any, b: any) => {
                        return a.label.localeCompare(b.label);
                    });
                }

                this.cityOptions.push(option);
            });

            this.cityOptions.sort((a: any, b: any) => {
                return a.label.localeCompare(b.label);
            });
        });
    }
}
